var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer" }, [
    _c("div", { staticClass: "top-footer" }, [
      _c("div", { staticClass: "content content-top-footer" }, [
        _vm.model.imageEnabled
          ? _c("div", { staticClass: "wrapper-top-footer-logo" }, [
              _vm.model.imageEnabled
                ? _c("div", { staticClass: "tenant-image" }, [
                    _c("img", {
                      staticClass: "img-responsive",
                      attrs: {
                        src: _vm.model.image,
                        tabindex: "0",
                        "data-test-element": "footer-image",
                        alt: _vm.model.footerLogoImgAlt
                      }
                    })
                  ])
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "wrapper-top-footer" }, [
          _c(
            "ul",
            { staticClass: "link-footer-wrapper externalLink-footer-links" },
            _vm._l(_vm.model.links, function(link) {
              return _c("li", { key: link.text }, [
                _c(
                  "a",
                  {
                    staticClass: "external-link",
                    attrs: {
                      target: "_blank",
                      rel: "noopener noreferrer",
                      "data-test-element":
                        "footer-link-" + link.footerLinkTypeToDisplay,
                      href: link.url,
                      title: link.tooltip
                    }
                  },
                  [_vm._v(_vm._s(link.text))]
                )
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wrapper-top-footer" }, [
          _c(
            "ul",
            {
              staticClass:
                "externalLink-footer-wrapper externalLink-footer-links"
            },
            _vm._l(_vm.model.externalLinks, function(link, index) {
              return index < 3
                ? _c("li", { key: link.text }, [
                    link.speedBumpRequired
                      ? _c(
                          "a",
                          {
                            staticClass: "external-link",
                            attrs: {
                              "data-test-element": "external-link-" + link.id,
                              "data-target": "#" + link.id,
                              "data-toggle": "modal",
                              href: link.url,
                              title: link.tooltip
                            },
                            on: {
                              click: function($event) {
                                return _vm.showModal(link.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(link.text))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !link.speedBumpRequired
                      ? _c(
                          "a",
                          {
                            staticClass: "external-link",
                            attrs: {
                              target: "_blank",
                              rel: "noopener noreferrer",
                              "data-test-element": "external-link-" + link.id,
                              href: link.url,
                              title: link.tooltip
                            }
                          },
                          [_vm._v(_vm._s(link.text))]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "wrapper-top-footer" }, [
          _c(
            "ul",
            {
              staticClass:
                "externalLink-footer-wrapper externalLink-footer-links"
            },
            _vm._l(_vm.model.externalLinks, function(link, index) {
              return index >= 3
                ? _c("li", { key: link.text }, [
                    link.speedBumpRequired
                      ? _c(
                          "a",
                          {
                            staticClass: "external-link",
                            attrs: {
                              "data-test-element": "external-link-" + link.id,
                              "data-target": "#" + link.id,
                              "data-toggle": "modal",
                              href: link.url,
                              title: link.tooltip
                            },
                            on: {
                              click: function($event) {
                                return _vm.showModal(link.id)
                              }
                            }
                          },
                          [_vm._v(_vm._s(link.text))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !link.speedBumpRequired
                      ? _c(
                          "a",
                          {
                            staticClass: "external-link",
                            attrs: {
                              target: "_blank",
                              rel: "noopener noreferrer",
                              "data-test-element": "external-link-" + link.id,
                              href: link.url,
                              title: link.tooltip
                            }
                          },
                          [_vm._v(_vm._s(link.text))]
                        )
                      : _vm._e()
                  ])
                : _vm._e()
            }),
            0
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bottom-footer" }, [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", [
            _vm.model.ncuaLogoEnabled
              ? _c("img", {
                  staticClass: "ncua-Logo fillColor",
                  class: {
                    forceNCUALogoMargin: _vm.model.ehlLogoEnabled == false
                  },
                  attrs: {
                    src: _vm.model.ncuaLogoImage,
                    tabindex: "0",
                    id: "ncuaSvgObject",
                    "data-test-element": "footer-NCUA",
                    alt: "National Credit Union Administration"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.model.ehlLogoEnabled
              ? _c("img", {
                  staticClass: "ehl-Logo fillColor",
                  class: {
                    forceNCUALogoMargin: _vm.model.ehlLogoEnabled == true
                  },
                  attrs: {
                    src: _vm.model.ehlLogoImage,
                    tabindex: "0",
                    id: "ehlSvgObject",
                    "data-test-element": "footer-EHL",
                    alt: "Equal Housing Lender"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.model.additionalText
              ? _c("div", {
                  staticClass:
                    "white-space-pre-wrap footer-additional-text additional-text-alignment",
                  attrs: {
                    tabindex: "0",
                    "data-test-element": "footer-additionalText"
                  },
                  domProps: { innerHTML: _vm._s(_vm.model.additionalText) }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c("div", { staticClass: "footer-copyright" }, [
            _c("div", {
              staticClass: "white-space-pre-wrap",
              attrs: { tabindex: "0", "data-test-element": "footer-copyright" },
              domProps: { innerHTML: _vm._s(_vm.model.copyright) }
            })
          ]),
          _vm._v(" "),
          _vm._l(_vm.model.externalLinks, function(link) {
            return _c(
              "div",
              {
                staticClass: "speed-bump modal fade",
                attrs: {
                  id: link.id,
                  tabindex: "-1",
                  role: "dialog",
                  "aria-hidden": "true"
                }
              },
              [
                link.speedBumpRequired
                  ? _c(
                      "div",
                      {
                        staticClass: "modal-dialog",
                        attrs: { role: "document" }
                      },
                      [
                        _c("div", { staticClass: "modal-content" }, [
                          _c("div", { staticClass: "modal-header" }, [
                            _c(
                              "h5",
                              {
                                staticClass:
                                  "modal-title modal-title-long-text",
                                attrs: {
                                  "data-test-element": "external-link-title"
                                }
                              },
                              [_vm._v(_vm._s(link.text))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "close",
                                attrs: {
                                  title: "Close",
                                  "data-dismiss": "modal",
                                  "data-test-element": "close-modal-" + link.id
                                }
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("close")
                                ])
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "modal-body" },
                            [
                              _c("alerts", {
                                attrs: { "alert-context": "terms" }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "modal-panel",
                                  attrs: {
                                    "data-test-element":
                                      "externalLink-SpeedBumpMessage-txt"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.model.speedBumpText) +
                                      "\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "a",
                              {
                                staticClass: "button button-link",
                                attrs: {
                                  target: "_blank",
                                  rel: "noopener noreferrer",
                                  href: link.url,
                                  autofocus: "autofocus",
                                  "data-test-element":
                                    "externalLink-continue-link"
                                },
                                on: { click: _vm.hideModal }
                              },
                              [_vm._v(_vm._s(_vm.$t("shared:action:continue")))]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "button-secondary",
                                attrs: {
                                  "data-dismiss": "modal",
                                  "data-test-element":
                                    "externalLink-cancel-link"
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("shared:action:cancel")))]
                            )
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          })
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5af5b946", { render: render, staticRenderFns: staticRenderFns })
  }
}